import { ErrorResponse, GlobalVariableValues, MessageParameters, MessageRequest, PackingStatus, PalletType, ProductCategoryEnum, StockTypeStatus, TransactionType } from '@gtpl/shared-models/common-models';
import { FgStockReportResponse, ForkLiftItemsDTO, ForkLiftJobDTO, getAllStockInDetailsResponseModel, GetForkLiftJobResponseModel, GetReportedPalletsResponseModel, Pallets, PalletSuggestionDto, ReportingStockDto, SaleOrderIdRequest, StockDTO, StockInDto, StockInReportResponseDto, StockInReportResponseModel, StockInRequestDto, StockInResponseDto, StockInResponseModel, StockInVerfication, StockOutModel, StockOutResponseDto, SuggestPalletResponseModel, SuggestPalletTypeResponseModel, WarehouseDashboardResponseModel } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, getManager, Repository } from 'typeorm';
import { StockInAdapter } from './dto/stock-in.adapter';
import { StockIn } from './stock-in.entity';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ForkLiftJobService, FGStockService, StockInRequest, StockInPrinResponse } from '@gtpl/shared-services/warehouse-management';
import { StoreConsumptionService } from '@gtpl/shared-services/procurement';
import { PackingMethodService, PalletService, RackPositionService, ZoneService } from '@gtpl/shared-services/masters';
import { SuggestPalletRequest } from './dto/suggest-pallet.request';
import { ReportedStockRequest } from './dto/reported-stock.request';
import { groupBy, retry } from 'rxjs/operators';
import { PalletRequest } from './dto/pallet.request';
import { ForkLiftJobStatus } from '../fork-lift-jobs/dto/fork-lift-job-status.enum';
import { ForkJobPurpose } from '../fork-lift-jobs/dto/fork-job-purpose.enum';
import { FgStockStatus } from '../stock/dto/fg-stock-status.enum';
import { StockStatus } from '../stock/dto/stock-status.enum';
import { ApiRequestTimeoutResponse } from '@nestjs/swagger';
import { InputIdRequest } from '../stock/dto/input-id.request';
import { SaleOrderItemsBySoIdReaponseModel } from '@gtpl/shared-models/sale-management';
import { ForkLiftJobs } from '../fork-lift-jobs/fork-lift-jobs.entity';
import { ForkLiftItems } from '../fork-lift-items/fork-lift-items.entity';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { StockRepository } from '../stock/repositories/stock-repository';
import appSettings from 'apps/services/config';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
import { StockInRepository } from './dto/stock-in.repository';
import { StockInPrintRequest } from './dto/stockin-print-request';
import { StockinPrintResponseModel } from 'libs/shared-services/warehouse-management/src/lib/stock-in-print-resonsemodel';
import { TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { PlaceListPalletDto } from '@gtpl/shared-models/procurement-management';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import whatsApp from 'apps/services/whatsapp';
import moment from 'moment';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import excessStockInPercentage from './dto/excess-percentage.dto';
@Injectable()
export class StockInService {
    constructor(
        @InjectRepository(StockIn)
        private stockInRepository: Repository<StockIn>,
        private stockInAdapter: StockInAdapter,
        private saleOrderService: SaleOrderService,
        private stockService: FGStockService,
        private palletService: PalletService,
        private packingMethodService: PackingMethodService,
        private forkLiftJobService: ForkLiftJobService,
        private storeConsumptionService: StoreConsumptionService,
        private rackPositionService: RackPositionService,
        private zoneService: ZoneService,
        private wpService: WhatsAppNotificationService,
        private wtsAppBroadCatService: WhatsappBroadCastService,
    ) { }

    async reportStockIn(stockInDto: StockInDto, isUpdate: boolean): Promise<StockInResponseModel> {
        try {
            console.log(stockInDto);
            const saleOrderId = stockInDto.saleOrderId;
            const saleOrderItemId = stockInDto.saleOrderItemId;
            const reportingCases = stockInDto.reportingCases;
            const reportedData = stockInDto.reportingDate;
            const convertedStockInEntity: StockIn = this.stockInAdapter.convertDtoToEntity(stockInDto, isUpdate);
            const savedStockInEntity: StockIn = await this.stockInRepository.save(convertedStockInEntity);
            if (savedStockInEntity) {
                console.log('Just now saved ' + savedStockInEntity.reportingLogId);
                const updateSaleOrdeItems = await this.saleOrderService.updateReportingCases({ saleOrderId: saleOrderId, saleOrderItemId: saleOrderItemId, reportingCases: reportingCases, reportedDate: reportedData });
                console.log('updateSaleOrdeItems' + updateSaleOrdeItems);
                if (updateSaleOrdeItems) {
                    if (stockInDto.transactionType === TransactionType.unregistered) {
                        const getjobDetails = await getConnection().createQueryBuilder().from(ForkLiftItems, "ForkLiftItems").leftJoin("fork_lift_jobs", "forkLiftJobInfo", "forkLiftJobInfo.job_id = ForkLiftItems.fork_lift_job_id").where("pallet = " + stockInDto.palletId).andWhere("forkLiftJobInfo.unit_id =" + stockInDto.plantId).andWhere("forkLiftJobInfo.status NOT IN ('Cancelled', 'Completed')").getRawOne();
                        console.log(getjobDetails);
                        if (getjobDetails != undefined) {
                            const updateProductInfo = await getConnection()
                                .createQueryBuilder()
                                .update(ForkLiftItems)
                                .set({ saleOrderId: stockInDto.saleOrderId, saleOrderItemId: stockInDto.saleOrderItemId })
                                .where(
                                    'forkLiftItemId = ' + getjobDetails.fork_lift_item_id
                                )
                                .execute();
                            if (updateProductInfo.affected > 0) {
                                const updateJobInfo = await getConnection()
                                    .createQueryBuilder()
                                    .update(ForkLiftJobs)
                                    .set({ reportedId: savedStockInEntity.reportingLogId })
                                    .where(
                                        'jobId = ' + getjobDetails.fork_lift_job_id
                                    )
                                    .execute();
                                if (updateJobInfo.affected > 0) {
                                    return new StockInResponseModel(true, 10000, "Unregistered Job product details updated successfully. ");
                                }
                                else {
                                    throw new ErrorResponse(11106, 'job update failed.');
                                }
                            }
                            else {
                                throw new ErrorResponse(11106, 'job update failed.');
                            }
                        }
                        else {
                            throw new ErrorResponse(11106, 'Unregistered Job not found.');
                        }
                    }
                    else {

                        /**creating fork lift job when reported */
                        const forkLiftJobItemsInfo: ForkLiftItemsDTO[] = [];
                        const forkLiftJobItemsData = new ForkLiftItemsDTO(stockInDto.saleOrderId, stockInDto.saleOrderItemId, stockInDto.palletId, 0, stockInDto.rackPostion, 0, new Date(), "Admin");
                        forkLiftJobItemsInfo.push(forkLiftJobItemsData);
                        const forkLiftJobData = new ForkLiftJobDTO(0, "", new Date(), ForkLiftJobStatus.Open, savedStockInEntity.reportingLogId, savedStockInEntity.transactionType, forkLiftJobItemsInfo, "Admin", stockInDto.plantId, "");
                        const raiseForkLiftJob = await this.forkLiftJobService.createForkLiftJob(forkLiftJobData);
                        console.log("raiseForkLiftJob" + raiseForkLiftJob.status)
                        if (raiseForkLiftJob.status) {
                            console.log("hi")
                            console.log(stockInDto.rackPostion)
                            const rackDetails = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: stockInDto.rackPostion });
                            console.log(rackDetails.status)
                            console.log('rackDetailsrackDetails' + rackDetails.data.rackCode);
                            const savedStockInDto = new StockInResponseDto(savedStockInEntity.saleOrderId, savedStockInEntity.saleOrderItemId, savedStockInEntity.reportedCases, savedStockInEntity.palletId, savedStockInEntity.rackPostion, savedStockInEntity.loosePouches, savedStockInEntity.lotCode, savedStockInEntity.palletId, savedStockInEntity.packingCompleted, savedStockInEntity.shift, savedStockInEntity.reportingDate, rackDetails.data.rackCode);
                            const updateRackPostionOccupancy = await this.rackPositionService.updateRackPostionOccupancy({ rackId: savedStockInEntity.rackPostion });
                            console.log(updateRackPostionOccupancy);
                            return new StockInResponseModel(true, 10000, "Stock reported successfully, Fork lift job raised against reported stock. ", savedStockInDto);
                        }
                        else {
                            throw new ErrorResponse(11106, 'Fork lift job creation failed');
                        }
                    }
                } else {
                    throw new ErrorResponse(11106, 'Reported Cases not updated,Something went wrong.');
                }
            } else {
                throw new ErrorResponse(11106, 'Something Went Wrong');
            }
        } catch (error) {
            return error;
        }
    }
    async reportStock(stockInDto: StockInRequestDto, isUpdate: boolean): Promise<StockInReportResponseModel> {
        console.log('----stockDto-----', stockInDto.rackPostion);
        const manager = getManager();
        const getSOItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockInDto.saleOrderId, saleOrderItemId: stockInDto.saleOrderItemId });
        try {
            stockInDto.variantId = getSOItemDetails.status ? getSOItemDetails.data.varientId : 0
            stockInDto.brandId = getSOItemDetails.status ? getSOItemDetails.data.masterBrandId : 0
            stockInDto.packStyleId = stockInDto.packStyleId != undefined ? stockInDto.packStyleId : getSOItemDetails.status ? getSOItemDetails.data.packStyleId : 0
            stockInDto.stockType = stockInDto.stockType
            stockInDto.palletCode = stockInDto.palletCode
            stockInDto.productCategory = stockInDto.productCategory
            console.log("stockInDtostockInDto");
            console.log(stockInDto);
            const convertedStockInEntity: StockIn = this.stockInAdapter.convertDtoToEntity(stockInDto, isUpdate);
            const savedStockInEntity: StockIn = await this.stockInRepository.save(convertedStockInEntity);
            console.log('savedStockEntity', savedStockInEntity);
            if (savedStockInEntity) {
                console.log('saved ' + savedStockInEntity.reportingLogId);
                let stockType;
                let stockId;
                let totalCartons = 0;
                let totalPouches = 0;
                let loosePouches = 0;
                let stockInQty = 0;

                const getStockData = await this.stockService.getStockBySoItemId({ saleOrderItemId: stockInDto.saleOrderItemId, location: stockInDto.rackPostion, stockType: stockInDto.stockType, pouchesShortage: stockInDto.pouchesStatus, cartonsShortage: stockInDto.cartonsStatus, productCategory: stockInDto.productCategory, packStyleId: stockInDto.packStyleId });
                console.log('getStockData', getStockData);
                if (getStockData.status) {
                    stockType = "Update";
                    stockId = getStockData.data.stockId;
                    stockInQty = Number(getStockData.data.stockInQty) + Number(stockInDto.reportingCases);
                    totalCartons = Number(getStockData.data.totalCartons) + Number(stockInDto.reportingCases);
                    totalPouches = Number(totalCartons) * Number(getSOItemDetails.data.pouches);
                    loosePouches = Number(getStockData.data.loosePouches) + Number(stockInDto.loosePouches);
                }
                else {
                    stockType = "Create";
                    stockId = 0;
                    totalCartons = stockInDto.reportingCases;
                    stockInQty = stockInDto.reportingCases;
                    totalPouches = stockInDto.reportingCases * getSOItemDetails.data.pouches;
                    loosePouches = stockInDto.loosePouches;
                }
                const palletCapacity = await this.packingMethodService.getPalletCapacity({ pouchesPerRow: getSOItemDetails.data.pouchWeight, noOfPouches: getSOItemDetails.data.pouches, uomId: getSOItemDetails.data.uomId })
                console.log(stockType);
                console.log('********', stockInDto)
                const manager = getManager();
                const query = `SELECT zone_id AS zoneId FROM ` + appSettings.masters_db + `.rack_position r 
                where r.rack_position_id=`+ stockInDto.rackPostion;
                console.log(query);
                const ZoneDetails = await manager.query(query);
                console.log(ZoneDetails);
                console.log('totalCartons' + totalCartons + 'totalPouches' + totalPouches + 'loosePouches' + loosePouches);
                const stockData = new StockDTO(stockInDto.saleOrderId, stockInDto.saleOrderItemId, totalCartons, totalPouches, loosePouches, stockInDto.rackPostion, stockInDto.palletId, stockInDto.reportingDate, stockInDto.stockType, FgStockStatus.StockIn, stockInDto.lotCode, stockInDto.transactionType, stockInDto.shifts, stockInDto.packingCompleted, stockId, getSOItemDetails.data.masterBrandId, getSOItemDetails.data.minGrade, getSOItemDetails.data.maxGrade, getSOItemDetails.data.varientId, getSOItemDetails.data.pouches, getSOItemDetails.data.pouchWeight, getSOItemDetails.data.categoryId, getSOItemDetails.data.productId, undefined, undefined, undefined, undefined, null, stockInDto.count, stockInDto.plantId, palletCapacity.status ? palletCapacity.data.palletCapacity : 0, stockInDto.cartonsStatus, stockInDto.pouchesStatus, stockInDto.productCategory, stockInDto.traceCode, getSOItemDetails.data.uomId, stockInQty, stockInDto.jobId, stockInDto.isDamaged, stockInDto.remarks, ZoneDetails[0].zoneId, stockInDto.packStyleId, stockInDto.palletCode);
                const updateStock = stockType === "Create" ? await this.stockService.createReportedStock(stockData) : await this.stockService.updateStock(stockData);
                console.log("updateStock.data" + updateStock);
                console.log("updateStock.status" + updateStock.status);

                // console.log('updateStock RK');
                const palletCodeStock = updateStock?.data['pallet_code'];
                let statusFlag = true

                if (stockInDto.saleOrderItemId != undefined) {
                    const updateSaleOrdeItems = await this.saleOrderService.updateReportingCases({ saleOrderId: stockInDto.saleOrderId, saleOrderItemId: stockInDto.saleOrderItemId, reportingCases: stockInDto.reportingCases, reportedDate: stockInDto.reportingDate });
                    console.log('updateSaleOrdeItems' + updateSaleOrdeItems);
                    console.log('updateSaleOrdeItems' + updateSaleOrdeItems.status);

                    if (updateSaleOrdeItems) {

                    }
                }
                if (stockInDto.stockType === "dummy") {
                    let getPackingInfo = await manager.query("SELECT soi.po_number AS poNumber,act_edl_date AS eta,DATEDIFF(NOW(),soi.act_edl_date),sku.variant_code AS varientCode,so.sale_order_id FROM " + appSettings.sales_db + ".sale_order_items si LEFT JOIN " + appSettings.sales_db + ".sale_order so ON so.sale_order_id = si.sale_order_id LEFT JOIN " + appSettings.masters_db + ".`sku_codes` sku ON sku.sku_code_id = si.varient_id LEFT JOIN " + appSettings.sales_db + ".`so_invoice_details` soi ON soi.sale_order_id = so.sale_order_id WHERE varient_id = " + getSOItemDetails.data.varientId + " AND so.status NOT IN ('CLOSED','CANCELLED') AND soi.processing_unit = " + stockInDto.plantId + " AND so.so_process_type = 'MTO' AND DATEDIFF(NOW(),soi.act_edl_date) < 15");
                    console.log(getPackingInfo);
                    if (getPackingInfo.length > 0) {
                        let urlMsg = '👇click the below link for report :';
                        let reportUrl = appSettings.whatsapp_redirection_url + '/stock-in-transactions';
                        let content: String[] = [];
                        let msg
                        for (const res of getPackingInfo) {
                            msg = "\n" +
                                "\Po Number : *" + (res.poNumber + '*\n') +
                                "\Product sku: *" + (res.varientCode + '*\n') +
                                "\ETA: *" + (moment(res.eta).format("YYYY-MM-DD") + '*\n');
                            content.push(msg);
                        }
                        let message;
                        message = content +
                            "\n*" + urlMsg + reportUrl + "*\n"
                        console.log(message);
                        const messageReq = await new MessageRequest("917382921217",
                            "Reported Dummy while packing material avaialable:",
                            message, "ERPX")
                        const time = moment().format('MMMM Do, YYYY')

                        // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(14,message,["917382921217@c.us"]));
                        // // var messageStatus = await this.wpService.sendPersonalMessage(messageReq);
                        // if (messageStatus?.status) {
                        //     return new CommonResponse(true, 11108, "Message Sent Sucessfully", messageStatus)
                        // }
                    }
                }
                if (updateStock.status) {
                    console.log("stocccckkkkkkkkkk")
                    const updateStockId = await this.stockInRepository.update({ reportingLogId: savedStockInEntity.reportingLogId, palletCode: savedStockInEntity.palletCode }, { stockId: updateStock.data.stockId, palletCode: palletCodeStock });
                    console.log("updateStockId" + updateStockId);
                    const updateSoTrackProdStatus = await this.saleOrderService.updateSoTrackProdStatus({ saleOrderId: stockInDto.saleOrderId, plantId: undefined, itemId: undefined, poNumber: undefined, stockOutType: undefined, stockType: stockInDto.stockType });
                    const updateRackPosition = await this.rackPositionService.updateRackPostionOccupancy({ rackId: stockInDto.rackPostion, saleOrderId: updateStock.data.saleOrderId });
                    if (updateSoTrackProdStatus.status && updateRackPosition.status && updateStockId.affected > 0) {
                        const rackPosition = await manager.query("Select rack_position_id As rackPositionId, rack_code As rackCode from " + appSettings.masters_db + ".rack_position r where r.rack_position_id = " + savedStockInEntity.rackPostion);
                        const stock = new StockInReportResponseDto(palletCodeStock, savedStockInEntity.reportingLogId, rackPosition[0].rackCode);
                        let query1 = ` SELECT u.unit_name AS unitName, sd.job_type AS jobType, job_cases as orderedCartons,cases,reported_cases,b.brand_name AS brandName,CONCAT(p.packing_method_name,'-',sk.variant_code) AS vcode ,po_number AS poNumber,SUM(total_cartons) AS reportedcases,ROUND(((SUM(total_cartons)/job_cases)*100))- 100 AS percenetage FROM `+appSettings.sales_db+`.sale_order_items si LEFT JOIN `+appSettings.masters_db+`.sku_codes sk ON sk.sku_code_id=si.varient_id LEFT JOIN `+appSettings.sales_db + `.so_invoice_details sd ON sd.sale_order_id = si.sale_order_id LEFT JOIN `+appSettings.masters_db+`.unitcodes u on u.unit_code_id = sd.processing_unit LEFT JOIN `+appSettings.warehouse_db+`.stock s ON s.sale_order_item_id=si.sale_order_item_id LEFT JOIN `+appSettings.masters_db+`.packing_methods p ON p.packing_method_id = s.pack_style_id LEFT JOIN `+appSettings.masters_db+`.brands b ON b.brand_id = si.brand_id WHERE si.sale_order_id=`+stockInDto.saleOrderId+` AND si.sale_order_item_id=`+stockInDto.saleOrderItemId+` HAVING percenetage > `+excessStockInPercentage.percentage
                        const result = await manager.query(query1);
                        let urlMsg = '👇click the below link for report :';
                        let reportUrl = appSettings.whatsapp_redirection_url + '/stock-in-transactions';
                        let message;
                        if (result.length > 0) {
                            const time = moment().format("DD-MM-YYYY HH:mm")
                            const parameters = [
                                // { "type": "text", "text": excessStockInPercentage.percentage},
                                { "type": "text", "text": time},
                                { "type": "text", "text": result[0].unitName != undefined ? result[0].unitName : "No Data" },
                                { "type": "text", "text": result[0].jobType != undefined ? result[0].jobType : "No Data" },
                                { "type": "text", "text": result[0].poNumber != undefined ? result[0].poNumber : "No Data" },
                                { "type": "text", "text": result[0].vcode != undefined ? result[0].vcode : "No Data" },
                                { "type": "text", "text": result[0].orderedCartons > 0 ? result[0].orderedCartons : "No Data" },
                                { "type": "text", "text": result[0].reportedcases > 0 ? result[0].reportedcases : "No Data" },
                                { "type": "text", "text": result[0].percenetage > 0 ? result[0].percenetage : "No Data" }];
                                console.log("parameters");
                        console.log(parameters);
                        const contacts = whatsApp.contacts;
                
                        for(const contact of contacts){
                            console.log(contact)
                            const req = await new MessageParameters(contact, 'stockin_excess', parameters)
                            const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                            console.log(messageStatus)
                            if(messageStatus.status){
                                const whatsapplogDto = new WhatsAppLogDto(contact,'stockin_excess','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.warehouseModuleId)
                                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                            }
                            else{
                                statusFlag = false
                            }

                        }
                   
                    // if (statusFlag) {
                    //     return new CommonResponse(true, 11108, "Message Sent Sucessfully")
                    // }
                    }
                    const response = new StockInReportResponseModel(true, updateStock.status ? 11100 : 11101, updateStock ? 'Stock Reported Successfully. ' : 'Something went wrong', stock);
                    return response;
                    }
                    else {
                        throw new ErrorResponse(11106, 'Production Status not updated, something went wrong.');
                    }


                }

                

                // }

                // 
                // }
                // else{

                // }
            } else {
                throw new ErrorResponse(11106, 'Something Went Wrong');
            }
        } catch (error) {
            console.log(error)
            throw error;
        }
    }
    async reportStockData(stockInDto: StockInDto, isUpdate: boolean, request: Request): Promise<StockInResponseModel> {
        const saleOrderItemId = stockInDto.saleOrderItemId;
        const reportingCases = stockInDto.reportingCases;

        let message = "";
        let stockStatus = "";
        try {

            const convertedStockInEntity: StockIn = this.stockInAdapter.convertDtoToEntity(stockInDto, isUpdate);
            const savedStockInEntity: StockIn = await this.stockInRepository.save(
                convertedStockInEntity
            );
            const savedStockInDto: StockInDto = this.stockInAdapter.convertEntityToDto(savedStockInEntity);
            if (savedStockInDto) {
                const getSOItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: savedStockInDto.saleOrderId, saleOrderItemId: savedStockInDto.saleOrderItemId });

                const updateReportedCases = await this.saleOrderService.updateReportingCases({ saleOrderId: stockInDto.saleOrderId, saleOrderItemId: savedStockInDto.saleOrderItemId, reportingCases: reportingCases, reportedDate: savedStockInDto.reportingDate })
                console.log('updateReportedCases' + updateReportedCases);
                const soProcessType = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: stockInDto.saleOrderId })
                if (soProcessType.soProcessType === "MTO") {
                    stockStatus = StockStatus.SaleOrder;
                }
                else if (soProcessType.soProcessType === "MTS" && (getSOItemDetails.data.varient).includes('HLSO')) {
                    stockStatus = StockStatus.dummy;
                }
                else if (soProcessType.soProcessType === "MTS" && !(getSOItemDetails.data.varient).includes('HLSO')) {
                    stockStatus = StockStatus.superDummy;
                }

                const stockDto = new StockDTO(savedStockInDto.saleOrderId, savedStockInDto.saleOrderItemId, savedStockInDto.reportingCases, 1, 1, 1, savedStockInDto.palletId, savedStockInDto.reportingDate, stockStatus, FgStockStatus.StockIn, savedStockInDto.lotCode, savedStockInDto.transactionType, savedStockInDto.shifts, savedStockInDto.packingCompleted, getSOItemDetails.data.brandId, getSOItemDetails.data.minGrade, getSOItemDetails.data.maxGrade, getSOItemDetails.data.varientId, getSOItemDetails.data.pouches, getSOItemDetails.data.pouchWeight, getSOItemDetails.data.categoryId, getSOItemDetails.data.productId);
                const addStock = await this.stockService.createStock(stockDto);
                if (addStock) {
                    message = "Stock reported successfully. ";
                }
                else {
                    message = "Something went wrong. ";
                }
                const response = new StockInResponseModel(true, savedStockInDto ? 1100 : 1101, savedStockInDto ? message : message, savedStockInDto);
                return response;
            } else {
                throw new ErrorResponse(11106, 'Something Went Wrong');
            }
        } catch (error) {
            return error;
        }
    }

    async getReportedStockBySoId(reportedStockRequest: ReportedStockRequest): Promise<GetReportedPalletsResponseModel> {
        try {
            const data: StockInDto[] = [];
            const reportedPallets = await this.stockInRepository.createQueryBuilder("Reporting")
                .where("sale_order_item_id = " + reportedStockRequest.saleOrderItemId)
                .groupBy('pallet_id').getMany();
            console.log(reportedPallets);
            for (const eachItem of reportedPallets) {
                // console.log(eachItem);
                const reportedData = new StockInDto(eachItem.saleOrderId, eachItem.saleOrderItemId, eachItem.reportedCases, PalletType.new, eachItem.palletId, eachItem.rackPostion, eachItem.loosePouches, eachItem.lotCode, eachItem.transactionType, eachItem.traceCode, eachItem.coldStorageId, eachItem.unitId, eachItem.shift, eachItem.packingCompleted, eachItem.stockType, eachItem.reportingDate, eachItem.manualReported, eachItem.createdUser, eachItem.updatedUser)
                data.push(reportedData);
            }
            if (reportedPallets) {
                const response = new GetReportedPalletsResponseModel(true, 11100, 'Reported Saleorder details retrived successfully', data);
                return response;
            }
        } catch (error) {
            return error;
        }
    }
    async suggestPallet(saleOrderIdRequest: SuggestPalletRequest): Promise<SuggestPalletResponseModel> {
        try {

            console.log(saleOrderIdRequest);
            let message = "";
            const newPalletData: Pallets[] = [];
            const existingPalletData: Pallets[] = [];
            const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: saleOrderIdRequest.saleOrderId, saleOrderItemId: saleOrderIdRequest.saleOrderItemId });
            console.log('saleOrderItemDetails' + saleOrderItemDetails.data);
            const checkSaleOrder = this.stockInRepository.createQueryBuilder("StockIn")
                .select(["pallet_id as palletId", "SUM(reported_cases) as reportedCases"])
                .where("sale_order_id =" + saleOrderIdRequest.saleOrderId)
                .andWhere("sale_order_item_id =" + saleOrderIdRequest.saleOrderItemId)
                .groupBy("pallet_id");
            const checkSaleOrderReport = await checkSaleOrder.getRawMany();
            console.log(checkSaleOrderReport);
            console.log(checkSaleOrderReport.length);
            // const checkPalletCapacity = await this.packingMethodService.getPalletCapacity({noOfPouches:saleOrderItemDetails.data.pouches,pouchesPerRow:saleOrderItemDetails.data.pouchWeight});
            // console.log('checkPalletCapacity'+checkPalletCapacity.data.palletCapacity);


            if (checkSaleOrderReport.length > 0) {
                for (const eachItem of checkSaleOrderReport) {
                    console.log(eachItem.reportedCases, saleOrderIdRequest.reportingQty);
                    // const calPalletCapacity = checkPalletCapacity.data.palletCapacity - (Number(eachItem.reportedCases) + Number(saleOrderIdRequest.reportingQty));
                    // const checkCapacity = (calPalletCapacity/checkPalletCapacity.data.palletCapacity)*100
                    // console.log('checkCapacity'+checkCapacity);
                    // if(checkCapacity >= 0){
                    const palletCodes = await this.palletService.getPalletById({ palletId: eachItem.palletId });
                    const existingPallets = new Pallets(palletCodes.data.palletId, palletCodes.data.palletNo);
                    existingPalletData.push(existingPallets);
                    message = "Exisiting pallets retrived Successfully. ";
                    // }
                    // else{
                    //     message = "Exisiting pallet capacity is not enough. ";
                    // }
                }
            }
            else {
                message = "Exisiting pallets not found, go for new pallet. ";
            }
            // if(saleOrderIdRequest.palletType == "Old"){
            //     const reportingStatus = await this.getReportedStockBySoId({saleOrderItemId:saleOrderIdRequest.saleOrderItemId})
            //     console.log(reportingStatus.data);
            //     if(reportingStatus){
            //         for (const eachItem of reportingStatus.data) {
            //             const pallet = await this.palletService.getPalletById({palletId:eachItem.palletId})
            //             console.log('palletpallet'+pallet.data);
            //             const oldPalletsData = new Pallets(pallet.data.palletCode);
            //             existingPalletData.push(oldPalletsData);
            //         }
            //     }
            // }
            // else if(saleOrderIdRequest.palletType == "New"){
            //     console.log("New");
            //     const newPallets = await this.palletService.getAllPallets();
            //     for (const eachItem of newPallets.data) {
            //         const newPalletsData = new Pallets(eachItem.palletCode);
            //         newPalletData.push(newPalletsData);

            //     }
            // }
            const data = new PalletSuggestionDto(existingPalletData, newPalletData);
            const response = new SuggestPalletResponseModel(true, 11100, message, data);
            return response;
        } catch (error) {
            return error;
        }
    }
    async checkPalletAvailability(palletRequest: PalletRequest): Promise<boolean> {
        try {
            let response = false;
            console.log(palletRequest);
            const checkPalletStatus = await this.palletService.getPalletById({ palletId: palletRequest.palletId });
            if (checkPalletStatus.data.isActive) {
                response = true;
            }
            else {
                response = false;
            }
            return response;

        } catch (error) {
            return error;
        }
    }

    async suggestPalletType(saleOrderIdRequest: SuggestPalletRequest): Promise<SuggestPalletTypeResponseModel> {
        try {
            console.log(saleOrderIdRequest);
            if (saleOrderIdRequest.saleOrderId != undefined && saleOrderIdRequest.saleOrderItemId != undefined && saleOrderIdRequest.reportingQty != undefined && saleOrderIdRequest.saleOrderId != 0 && saleOrderIdRequest.saleOrderItemId != 0 && saleOrderIdRequest.reportingQty != 0) {
                const data = [{ palletType: "Old Pallet" }, { palletType: "New Pallet" }];
                const response = new SuggestPalletTypeResponseModel(true, 1101, "Pallet Type Suggestion", data);
                return response;
            }
            else {
                throw new ErrorResponse(11106, 'Some inputs are missing, please check.');
            }
        } catch (error) {
            return error;
        }
    }

    /**
    * get product details for a pallet relared sale order item id
    * @param req 
    * @returns 
    */
    async productDetailsForPalletId(req: InputIdRequest): Promise<SaleOrderItemsBySoIdReaponseModel> {
        try {
            const saleOrderItemId = await this.stockInRepository.findOne({ select: ['saleOrderId', 'saleOrderItemId'], where: { palletId: req.inputId, stockId: null } });
            if (!saleOrderItemId) {
                throw new ErrorResponse(10000, 'Pallet not avaiable in transit');
            }
            return await this.saleOrderService.getProductDetailsBySoItemId({ saleOrderId: saleOrderItemId.saleOrderId, saleOrderItemId: saleOrderItemId.saleOrderItemId });
        } catch (error) {
            return error
        }
    }

    async getReportedStockForSoId(req: SaleOrderIdRequest): Promise<getAllStockInDetailsResponseModel> {
        try {
            const response: StockOutResponseDto[] = [];
            const data = await this.stockInRepository.find({ saleOrderId: req.saleOrderId, unitId: req.plantId });
            console.log(data);
            if (!data) {
                throw new ErrorResponse(10000, 'No data found. ');
            }
            else {
                for (const eachItem of data) {
                    let coldStorage = '';
                    if (eachItem) {
                        const zoneData = await this.zoneService.getZoneById({ zoneId: eachItem.coldStorageId });
                        coldStorage = (zoneData) ? zoneData.zoneName : '';
                    }
                    const saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: eachItem.saleOrderId, saleOrderItemId: eachItem.saleOrderItemId });
                    const rackPositionData = await this.rackPositionService.getRackPositionsForRackMasterId({ rackId: eachItem.rackPostion });
                    const palletData = await this.palletService.getPalletById({ palletId: eachItem.palletId });
                    const saleOrderData = await this.saleOrderService.getSaleOrderInformationById({ saleOrderId: eachItem.saleOrderId });
                    const data = new StockOutResponseDto(eachItem.stockId, eachItem.lotCode, saleOrderData.data.saleOrder, rackPositionData.data.rackName, (saleOrderItemDetails.data.noOfPouches * saleOrderItemDetails.data.pouchWeight), eachItem.reportedCases, eachItem.reportedCases * saleOrderItemDetails.data.noOfPouches, eachItem.loosePouches, saleOrderItemDetails.data.pouchWeight, "", coldStorage, eachItem.packingCompleted, 0, eachItem.rackPostion);
                    response.push(data);
                }
                console.log(response);

                return new getAllStockInDetailsResponseModel(true, 1010, "Reported data retrived successfully. ", response);
            }
        } catch (error) {
            console.log(error);
            return error
        }
    }

    // async getFgStockData(): Promise<FgStockReportResponse> {
    //     const response
    // }

    async reverseStockIn(req: StockInRequest): Promise<WarehouseDashboardResponseModel> {
        const manager = new GenericTransactionManager();
        const connection = getManager();
        try {
            await manager.startTransaction();
            let updateRackPosition: CommonResponse;
            let updateResult;
            const getStockInData = await this.stockInRepository.findOne({ where: { reportingLogId: req.reportingLogId } });
            const updateStockIn = await manager.getCustomRepository(StockInRepository).update({ reportingLogId: req.reportingLogId }, { isActive: false });
            console.log(updateStockIn);
            if (updateStockIn.affected > 0) {
                const getStockData = 'select * from ' + appSettings.warehouse_db + '.stock where stock_id = ' + getStockInData.stockId + ' and status ="StockIn"';
                const stockData = await connection.query(getStockData);
                console.log(stockData);

                let stockInQty = Number(stockData[0].stockin_qunatity) - Number(req.reportingCases);
                let totalCartons = Number(stockData[0].total_cartons) - Number(req.reportingCases);
                let stockUpdate;
                console.log("reverse cartons " + req.reportingCases);
                console.log("StockIn qty" + stockData[0].stockin_qunatity);
                console.log("StockIn out" + stockData[0].stockout_qunatity);
                console.log("cartons" + stockData[0].total_cartons);
                console.log("AFTER CALCULATION");
                console.log("StockIn qty" + stockInQty);
                console.log("Total Cartons" + totalCartons);


                if (stockInQty > 0) {
                    stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: getStockInData.stockId }, { stockInQty: stockInQty, totalCartons: totalCartons });
                }
                else {
                    stockUpdate = await manager.getCustomRepository(StockRepository).update({ stockId: getStockInData.stockId }, { status: FgStockStatus.Cancelled });
                    let getExistingStock = 'select * from ' + appSettings.warehouse_db + '.stock where status ="StockIn" and location = ' + getStockInData.rackPostion + ' and stock_id != ' + getStockInData.stockId;
                    const stockData = await connection.query(getExistingStock);
                    console.log(stockData);
                    if (stockData.length == 0) {
                        updateRackPosition = await this.rackPositionService.freeRackPostionOccupancy({ rackId: getStockInData.rackPostion });
                    }
                }
                if (stockUpdate.affected > 0) {
                    const getSaleOrderItemsDetails = 'select reported_cases AS reportedCases from ' + appSettings.sales_db + '.sale_order_items where sale_order_item_id = ' + getStockInData.saleOrderItemId;
                    const saleOrderItemDetails = await connection.query(getSaleOrderItemsDetails);
                    let reportedCases = saleOrderItemDetails[0].reportedCases - req.reportingCases;
                    const updateReportedCases = 'update ' + appSettings.sales_db + '.sale_order_items set reported_cases = ' + reportedCases + ' where sale_order_item_id = ' + getStockInData.saleOrderItemId;
                    updateResult = await connection.query(updateReportedCases);
                    console.log('updateReportedCases' + updateResult.affectedRows);
                }
                console.log(updateStockIn.affected + " " + stockUpdate.affected + "  " + updateResult.affectedRows)
                if (updateStockIn.affected > 0 && stockUpdate.affected > 0 && updateResult.affectedRows > 0) {
                    manager.completeTransaction();
                    return new WarehouseDashboardResponseModel(true, 1001, "Stock Reversed Successfully. ");
                }
                else {
                    manager.releaseTransaction();
                    return new WarehouseDashboardResponseModel(false, 1010, "Stock not found. ");
                }
            }
            else {
                manager.releaseTransaction();
                return new WarehouseDashboardResponseModel(false, 1010, "Stock not found. ");
            }
        }
        catch (error) {
            manager.releaseTransaction();
            console.log(error);
            return error
        }
    }
    async getStockInPrint(req: StockInPrintRequest): Promise<StockinPrintResponseModel> {
        try {
            const manager = getManager();
            let query = 'SELECT rp.pallet_code AS palletCode,pm.packing_method_name AS packmethodName,r.rack_code as rackPostion ,sk.variant_code AS varientcode,s.stock_type AS stocktype, b.brand_name AS brandName,c.client_name AS clientName,rp.reporting_log_id ,si.po_number AS customerPo,rp.transaction_type AS transactionType,rp.pouches_shortage AS poucShortage,rp.cartons_shortage AS cartonShortage,rp.reported_cases AS reportedCases FROM erpx_dev_warehouse.reporting rp LEFT JOIN erpx_dev_sales.so_invoice_details si ON si.sale_order_id=rp.sale_order_id LEFT JOIN `erpx_dev_masters`.`customers` c ON c.cust_id = si.customer_id  LEFT JOIN `erpx_dev_masters`.`packing_methods` pm ON pm.packing_method_id=rp.pack_style_id LEFT JOIN `erpx_dev_masters`.`brands` b ON b.brand_id=rp.brand_id LEFT JOIN `erpx_dev_warehouse`.`stock` s ON s.sale_order_id=rp.sale_order_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.sku_code_id = rp.variant_id LEFT JOIN `erpx_dev_masters`.rack_position r on rp.rack_postion=r.rack_position_id where reporting_log_id =" ' + req.reportingLogId + ' " '
            query = query + 'GROUP BY rp.reporting_log_id'
            const result: StockInPrinResponse[] = await manager.query(query)
            if (result) {
                return new StockinPrintResponseModel(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new StockinPrintResponseModel(false, 1111, "Error occure")

            }
        }
        catch (err) {
            return err;
        }


    }

    async reportStockInData(stockInDto: ReportingStockDto, isUpdate: boolean): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        const getSOItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: stockInDto.saleOrderId, saleOrderItemId: stockInDto.saleOrderItemId });
        try {
            await manager.startTransaction();
            stockInDto.variantId = getSOItemDetails.status ? getSOItemDetails.data.varientId : 0
            stockInDto.brandId = getSOItemDetails.status ? getSOItemDetails.data.masterBrandId : 0
            stockInDto.packStyleId = stockInDto.packStyleId != undefined ? stockInDto.packStyleId : getSOItemDetails.status ? getSOItemDetails.data.packStyleId : 0
            stockInDto.stockType = stockInDto.stockType
            const convertedStockInEntity: StockIn = this.stockInAdapter.SaveData(stockInDto, isUpdate);
            const savedStockInEntity: StockIn = await this.stockInRepository.save(convertedStockInEntity);
            // console.log('savedStockEntity');
            // console.log(savedStockInEntity);
            if (savedStockInEntity) {
                let itemDetails: ForkLiftItemsDTO[] = [];
                let jobItem = new ForkLiftItemsDTO(savedStockInEntity.saleOrderId, savedStockInEntity.saleOrderItemId, stockInDto.palletId, savedStockInEntity.rackPostion, savedStockInEntity.rackPostion, null, null, savedStockInEntity.createdUser, savedStockInEntity.updatedUser, undefined, "", "", "", "", "", "", "", "", "", 0, 0, "", 0, 0, stockInDto.reportingCases, stockInDto.plantId);
                console.log(jobItem);
                itemDetails.push(jobItem);
                let dto = new ForkLiftJobDTO(0, "", null, ForkLiftJobStatus.Open, savedStockInEntity.reportingLogId, TransactionType.palleting, itemDetails, savedStockInEntity.createdUser, savedStockInEntity.unitId, "", savedStockInEntity.updatedUser, savedStockInEntity.reportedCases, 0, 0, 0, 0, undefined, undefined);
                let raiseJob = await this.forkLiftJobService.createForkLiftJob(dto);
                console.log("raiseJob");
                console.log(raiseJob);
                let flag = false;
                if (raiseJob.status) {
                    let updateJobId = await this.stockInRepository.update({ reportingLogId: savedStockInEntity.reportingLogId }, { jobId: raiseJob.data.jobId })
                    if (updateJobId.affected > 0) {
                        let updateStoreConsumption = await this.storeConsumptionService.updateReportedStock({ storeConsumptionId: stockInDto.storeConsumptionId, rackPosition: 0, reportedCases: stockInDto.reportingCases });
                        if (updateStoreConsumption.status) {
                            let request = new PlaceListPalletDto(stockInDto.storeConsumptionId, stockInDto.rackPostion, stockInDto.palletId)
                            let updatePallet = await this.storeConsumptionService.updatePalletCodeInPlaceList(request);

                            if (updatePallet.status) {
                                flag = true;
                            }
                            else {
                                flag = false;
                            }
                        }
                        else {
                            await manager.releaseTransaction();
                            const response = new CommonResponse(false, 1010, 'Something went wrong. ', savedStockInEntity);
                            return response;
                        }
                    }
                    else {
                        await manager.releaseTransaction();
                        const response = new CommonResponse(false, 1010, 'Something went wrong. ', savedStockInEntity);
                        return response;
                    }
                }
                if (flag) {
                    await manager.completeTransaction();
                    const response = new CommonResponse(true, 1001, 'Stock Reported Successfully. ', savedStockInEntity);
                    return response;
                }
                else {
                    await manager.releaseTransaction();
                    const response = new CommonResponse(false, 1010, 'Something went wrong. ', savedStockInEntity);
                    return response;
                }
            } else {
                await manager.releaseTransaction();
                const response = new CommonResponse(false, 1010, 'Something went wrong. ', savedStockInEntity);
                return response;
            }
        } catch (error) {
            await manager.releaseTransaction();
            console.log(error)
            throw error;
        }
    }
    async stockPlacementVerification(req: StockInVerfication): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            let getReportingDetails = await this.stockInRepository.findOne({where: {
                    rackPostion: req.rackPostion, palletCode: req.palletCode, stockId: null, isActive: true
                }, order: { reportingLogId: 'DESC' }});
            console.log(getReportingDetails);
            let stockType;
            let stockId;
            let totalCartons = 0;
            let totalPouches = 0;
            let loosePouches = 0;
            let stockInQty = 0;
            if (getReportingDetails.reportingLogId > 0) {
                const getSOItemDetails = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: getReportingDetails.saleOrderId, saleOrderItemId: getReportingDetails.saleOrderItemId });
                const getStockData = await this.stockService.getStockBySoItemId({ saleOrderItemId: getReportingDetails.saleOrderItemId, location: getReportingDetails.rackPostion, stockType: getReportingDetails.stockType, pouchesShortage: PackingStatus.NO, cartonsShortage: PackingStatus.NO, productCategory: getReportingDetails.productCategory, packStyleId: getReportingDetails.packStyleId });
                console.log("getStockData");
                console.log(getStockData);
                if (getStockData.status) {
                    stockType = "Update";
                    stockId = getStockData.data.stockId;
                    stockInQty = Number(getStockData.data.stockInQty) + Number(getReportingDetails.reportedCases);
                    totalCartons = Number(getStockData.data.totalCartons) + Number(getReportingDetails.reportedCases);
                    totalPouches = Number(totalCartons) * Number(getSOItemDetails.data.pouches);
                    loosePouches = Number(getStockData.data.loosePouches) + Number(getReportingDetails.loosePouches);
                }
                else {
                    stockType = "Create";
                    stockId = 0;
                    totalCartons = getReportingDetails.reportedCases;
                    stockInQty = getReportingDetails.reportedCases;
                    totalPouches = getReportingDetails.reportedCases * getSOItemDetails.data.pouches;
                    loosePouches = getReportingDetails.loosePouches;
                }
                const zoneDetails = await this.rackPositionService.getRackDetailsById({ rackPositionId: getReportingDetails.rackPostion });
                const palletCapacity = await this.packingMethodService.getPalletCapacity({ pouchesPerRow: getSOItemDetails.data.pouchWeight, noOfPouches: getSOItemDetails.data.pouches, uomId: getSOItemDetails.data.uomId })
                totalPouches = Number(getReportingDetails.reportedCases) * Number(getSOItemDetails.data.pouches);
                const stockData = new StockDTO(getReportingDetails.saleOrderId, getReportingDetails.saleOrderItemId, getReportingDetails.reportedCases, totalPouches, getReportingDetails.loosePouches, getReportingDetails.rackPostion, getReportingDetails.palletId, getReportingDetails.reportingDate, getReportingDetails.stockType, FgStockStatus.StockIn, getReportingDetails.lotCode, getReportingDetails.transactionType, getReportingDetails.shift, getReportingDetails.packingCompleted, getReportingDetails.stockId, getSOItemDetails.data.masterBrandId, getSOItemDetails.data.minGrade, getSOItemDetails.data.maxGrade, getSOItemDetails.data.varientId, getSOItemDetails.data.pouches, getSOItemDetails.data.pouchWeight, getSOItemDetails.data.categoryId, getSOItemDetails.data.productId, undefined, undefined, undefined, undefined, null, 0, getReportingDetails.unitId, palletCapacity.status ? palletCapacity.data.palletCapacity : 0, PackingStatus.NO, PackingStatus.NO, getReportingDetails.productCategory, getReportingDetails.traceCode, getSOItemDetails.data.uomId, stockInQty, 0, getReportingDetails.productCategory === ProductCategoryEnum.damaged ? PackingStatus.YES : PackingStatus.NO, getReportingDetails.remarks, zoneDetails.status ? zoneDetails.data.zoneId : 0, getReportingDetails.packStyleId);
                const updateStock = stockType === "Create" ? await this.stockService.createReportedStock(stockData) : await this.stockService.updateStock(stockData);
                console.log("updateStock")
                console.log(updateStock);
                if (updateStock.status) {
                    const updateSaleOrdeItems = await this.saleOrderService.updateReportingCases({ saleOrderId: getReportingDetails.saleOrderId, saleOrderItemId: getReportingDetails.saleOrderItemId, reportingCases: getReportingDetails.reportedCases, reportedDate: getReportingDetails.reportingDate });
                    console.log(updateSaleOrdeItems);
                    if (updateSaleOrdeItems) {
                        const updateStockId = await this.stockInRepository.update({ reportingLogId: getReportingDetails.reportingLogId, palletCode: getReportingDetails.palletCode }, { stockId: updateStock.data.stockId });
                        const updateSoTrackProdStatus = await this.saleOrderService.updateSoTrackProdStatus({ saleOrderId: getReportingDetails.saleOrderId, plantId: undefined, itemId: undefined, poNumber: undefined, stockOutType: undefined, stockType: getReportingDetails.stockType });
                        const updateRackPosition = await this.rackPositionService.updateRackPostionOccupancy({ rackId: getReportingDetails.rackPostion, saleOrderId: updateStock.data.saleOrderId });
                        const updatePlaceList = await this.storeConsumptionService.updatePlaceListStatus({ storeConsumptionId: getReportingDetails.storeConsumptionId, rackPosition: getReportingDetails.rackPostion });
                        const updateForkLiftJob = await this.forkLiftJobService.updatePlaceListJob({ jobId: getReportingDetails.jobId, stockId: updateStock.data.stockId, rackPosition: getReportingDetails.rackPostion, reportedId: getReportingDetails.reportingLogId });
                        console.log(updateStockId.affected + "*****" + updateSoTrackProdStatus.status + "*****" + updateRackPosition.status + "*****" + updatePlaceList.status + "*****" + updateForkLiftJob.status)
                        if (updateStockId.affected > 0 && updateSoTrackProdStatus.status && updateRackPosition.status && updatePlaceList.status && updateForkLiftJob.status) {
                            await manager.completeTransaction();
                            return new CommonResponse(true, 1001, "Stock Updated Successfully. ",);
                        }
                        else {
                            await manager.releaseTransaction();
                            return new CommonResponse(false, 1001, "Something went wrong. ");
                        }
                    }
                    else {
                        await manager.releaseTransaction();
                        return new CommonResponse(false, 1001, "Something went wrong. ");
                    }
                }
                else {
                    await manager.releaseTransaction();
                    return new CommonResponse(false, 1001, "Something went wrong. ");
                }
            }
            else {
                await manager.releaseTransaction();
                return new CommonResponse(false, 1001, "Something went wrong. ");
            }

        } catch (error) {
            await manager.releaseTransaction();
            console.log(error)
            throw error;
        }
    }
    async getPalletsVerificationDropDown(req:PlantIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager();
            let query = 'select pallet_code AS palletCode, rack_postion AS rackPosition, rp.rack_code AS rackCode from '+appSettings.warehouse_db+'.reporting r left join '+appSettings.masters_db+'.rack_position rp on rp.rack_position_id = r.rack_position where is_active = true and plant_id = '+req.unitcodeId+' and stock_id = null';
            query = query + 'GROUP BY pallet_code'
            const result: StockInPrinResponse[] = await manager.query(query)
            if (result) {
                return new StockinPrintResponseModel(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new StockinPrintResponseModel(false, 1111, "Error occure")

            }
        }catch (error) {
            throw error;
        }
    }

    
}
